<script lang="ts">
  import ContainerChoiceTab from "./ContainerChoiceTab.svelte";
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";

  export let showDeals: boolean;
  export let showRecentlyOrdered: boolean;
  export let selectContainerType: (type: string) => void;
  export let selectedContainerType: string;
  export let containerTypes: string[] = [];
  export let isPricingLoading: boolean;

  $: minHeightStyle = $LayoutStore.isMobile ? "min-height: 55px" : "min-height: 60px";

  let containerTypesForDisplay: string[];
  $: {
    containerTypesForDisplay = [];
    if (showDeals) containerTypesForDisplay.push("deals");
    if (showRecentlyOrdered) containerTypesForDisplay.push("recentlyOrdered");
    containerTypesForDisplay = containerTypesForDisplay.concat(containerTypes);
  }
</script>

{#if isPricingLoading || containerTypesForDisplay.length > 0}
  <ul
    data-testid="container-choices"
    class="product-detail__product-tabs tabs-background list list--horizontal list--gutter-none align-center light-subheader--regular"
    style={minHeightStyle}
  >
    {#if !isPricingLoading}
      {#each containerTypesForDisplay as containerType (containerType)}
        <ContainerChoiceTab
          {containerType}
          {selectContainerType}
          isSelected={selectedContainerType === containerType}
        />
      {/each}
    {/if}
  </ul>
{/if}
